module.exports = __webpack_public_path__ + "static/media/shape0_5.5a05671d.obj";